/**
 * Chuỗi JSON an toàn để nhúng vào <script type="application/ld+json">.
 *
 * JSON.stringify KHÔNG escape "<", nên một review khách viết có chứa
 * "</script><script>…" sẽ đóng thẻ JSON-LD và chạy mã trên trang (XSS).
 * Escape < > & và U+2028/2029 thành \uXXXX — JSON vẫn hợp lệ, Google đọc y hệt.
 */
export const safeJsonLd = (data: unknown): string =>
  JSON.stringify(data)
    .replace(/</g, "\\u003c")
    .replace(/>/g, "\\u003e")
    .replace(/&/g, "\\u0026")
    .replace(/\u2028/g, "\\u2028")
    .replace(/\u2029/g, "\\u2029");

import DOMPurify from "isomorphic-dompurify";

/**
 * Lọc HTML richtext từ CMS trước khi dangerouslySetInnerHTML.
 * CMS chỉ admin nhập, nhưng vẫn chặn các vector chạy mã phổ biến.
 *
 * Trước đây dùng regex blacklist tự viết — lách được bằng `<img/onerror=`,
 * `<svg/onload=`, `href="java&#x73;cript:"` (HTML entity), và không chặn
 * svg/math (2 namespace có thể chèn script qua <svg><script>). Regex không
 * parse HTML thật nên không theo kịp mọi cách encode. Đổi sang
 * isomorphic-dompurify (chạy được cả server + browser) — parse DOM thật,
 * decode entity trước khi kiểm tra, whitelist thẻ/thuộc tính, chặn namespace
 * svg/math qua USE_PROFILES.
 */
export const sanitizeCmsHtml = (html?: string | null): string => {
  if (!html) return "";
  return DOMPurify.sanitize(String(html), {
    // USE_PROFILES: { html: true } bị bỏ — DOMPurify ưu tiên profile này và
    // BỎ QUA ALLOWED_TAGS/ALLOWED_ATTR tự khai báo dưới đây, nghĩa là
    // whitelist thẻ/thuộc tính thực ra không có tác dụng trước khi sửa.
    ALLOWED_TAGS: [
      "p", "br", "b", "strong", "i", "em", "u", "s", "span",
      "ul", "ol", "li", "a", "h1", "h2", "h3", "h4", "h5", "h6",
      "blockquote", "table", "thead", "tbody", "tr", "td", "th",
    ],
    ALLOWED_ATTR: ["href", "target", "rel", "class"],
    ALLOW_DATA_ATTR: false,
    FORBID_TAGS: ["svg", "math", "script", "style", "iframe", "object", "embed", "form"],
  });
};
